<template>
    <div>
        <template v-if="innerProduct !== null">
            <Buy
                v-if="innerProduct.cart.quantity === 0"
                :cart-position-id="innerProduct.id"
                :quantity="innerProduct.quantity"
                :quantity-cart="innerProduct.cart.quantity"
            />

            <CartQuantity
                v-if="innerProduct.cart.quantity > 0"
                :id="innerProduct.id"
                :value="innerProduct.cart.quantity"
                :min="min"
                :step="step"
            />
        </template>
    </div>
</template>

<script>

import Buy from './Buy';
import CartQuantity from "./CartQuantity";
import {EVENT_ON_CART_UPDATE} from "@/events";

export default {
    components: {
        Buy,
        CartQuantity,
    },
    props: {
        product: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            innerProduct: null,
        }
    },
    computed: {
        min: function () {
            if (this.innerProduct.weightMin === 0) {
                return 1;
            }
            return this.innerProduct.weightMin;
        },
        step: function () {
            if (this.innerProduct.weightStep === 0) {
                return 1;
            }
            return this.innerProduct.weightStep;
        }
    },
    created() {
        this.innerProduct = this.product;
        this.$root.$on(EVENT_ON_CART_UPDATE, this.onCartChanged);
    },
    beforeDestroy() {
        this.$root.$off(EVENT_ON_CART_UPDATE, this.onCartChanged);
    },
    methods: {
        onCartChanged(data) {
            const found = data.items.find(item => item.id === this.innerProduct.id);
            if (found !== undefined) {
                this.innerProduct = found.product;
            } else {
                this.innerProduct.cart.quantity = 0;
            }
        }
    },
}
</script>

<style scoped>

</style>